import { Validator } from "../../validation";

const COMMENT_MAX_LENGTH = 1000;

export const optionalCommentValidator = Validator.new().maxLength(COMMENT_MAX_LENGTH).build();
export const requiredCommentValidator = Validator.new().required().maxLength(COMMENT_MAX_LENGTH).build();
